import { Building2, MapPin, UserRound, Users } from 'lucide-react'
import type { ClienteAgradaDetail } from '@/services/clientesService'
import {
  FinanceDetailInfoRow,
  FinanceDetailSectionCard,
} from '@/components/Financeiro/FinanceDetailSectionCard'
import { formatDate } from '@/utils/format-date'
import {
  displayOrDash,
  formatClienteAgradaStatus,
  formatClienteCnpj,
} from './clienteAgradaDetailUtils'

type Props = {
  detail: ClienteAgradaDetail
}

export function ClienteAgradaCadastroTab({ detail }: Props) {
  return (
    <div className='grid gap-5 lg:grid-cols-2'>
      <FinanceDetailSectionCard title='Identificação' icon={Building2} accent='#ef4444'>
        <FinanceDetailInfoRow label='Razão social' value={displayOrDash(detail.razaoSocial)} />
        <FinanceDetailInfoRow
          label='Nome fantasia'
          value={displayOrDash(detail.nomeFantasia ?? detail.nome)}
        />
        <FinanceDetailInfoRow label='CNPJ' value={formatClienteCnpj(detail.cnpj)} />
        <FinanceDetailInfoRow label='Status' value={formatClienteAgradaStatus(detail.status)} />
        <FinanceDetailInfoRow label='Segmento' value={displayOrDash(detail.segmento)} />
        <FinanceDetailInfoRow label='Plataforma' value={displayOrDash(detail.plataforma)} />
        <FinanceDetailInfoRow label='Modelo' value={displayOrDash(detail.modelo)} />
        <FinanceDetailInfoRow label='Faturamento' value={displayOrDash(detail.faturamento)} />
        <FinanceDetailInfoRow label='Tráfego' value={displayOrDash(detail.trafego)} />
        <FinanceDetailInfoRow label='Cadastro' value={formatDate(detail.createdAt)} />
        <FinanceDetailInfoRow label='Última atualização' value={formatDate(detail.updatedAt)} />
      </FinanceDetailSectionCard>

      <FinanceDetailSectionCard title='Contato principal' icon={UserRound} accent='#3b82f6'>
        <FinanceDetailInfoRow label='Contato' value={displayOrDash(detail.contato)} />
        <FinanceDetailInfoRow label='Cargo' value={displayOrDash(detail.cargo)} />
        <FinanceDetailInfoRow label='E-mail' value={displayOrDash(detail.email)} />
        <FinanceDetailInfoRow label='Telefone' value={displayOrDash(detail.telefone)} />
        <FinanceDetailInfoRow label='Website' value={displayOrDash(detail.site)} />
      </FinanceDetailSectionCard>

      <FinanceDetailSectionCard title='Endereço' icon={MapPin} accent='#10b981'>
        <FinanceDetailInfoRow label='Endereço' value={displayOrDash(detail.endereco)} />
        <FinanceDetailInfoRow label='CEP' value={displayOrDash(detail.cep)} />
        <FinanceDetailInfoRow label='Cidade' value={displayOrDash(detail.cidade)} />
        <FinanceDetailInfoRow label='Estado' value={displayOrDash(detail.estado)} />
      </FinanceDetailSectionCard>

      <FinanceDetailSectionCard title='Responsáveis' icon={Users} accent='#f59e0b'>
        <FinanceDetailInfoRow
          label='Resp. assinatura'
          value={displayOrDash(detail.responsavelAssinaturaNome)}
        />
        <FinanceDetailInfoRow
          label='E-mail assinatura'
          value={displayOrDash(detail.responsavelAssinaturaEmail)}
        />
        <FinanceDetailInfoRow
          label='Resp. financeiro'
          value={displayOrDash(detail.responsavelFinanceiroNome)}
        />
        <FinanceDetailInfoRow
          label='E-mail financeiro'
          value={displayOrDash(detail.responsavelFinanceiroEmail)}
        />
        <FinanceDetailInfoRow
          label='Parceiro'
          value={
            detail.parceiro
              ? `${detail.parceiro.nome}${detail.parceiro.empresa ? ` — ${detail.parceiro.empresa}` : ''}`
              : '—'
          }
        />
      </FinanceDetailSectionCard>

      {(detail.contatos?.length ?? 0) > 0 && (
        <FinanceDetailSectionCard
          title='Contatos vinculados'
          icon={Users}
          accent='#987de8'
          className='lg:col-span-2'
        >
          <div className='grid gap-3 sm:grid-cols-2'>
            {detail.contatos.map((c) => (
              <div
                key={c.id}
                className='rounded-xl border border-white/[0.06] bg-white/[0.03] p-4'
              >
                <div className='mb-2 flex items-center justify-between gap-2'>
                  <p className='font-semibold text-text-primary'>{c.nome}</p>
                  {c.decisor && (
                    <span className='rounded-full bg-accent/15 px-2 py-0.5 text-[10px] font-semibold uppercase text-accent'>
                      Decisor
                    </span>
                  )}
                </div>
                <p className='text-sm text-text-muted'>{displayOrDash(c.cargo)}</p>
                <p className='mt-2 text-sm text-text-primary'>{displayOrDash(c.email)}</p>
                <p className='text-sm text-text-muted'>{displayOrDash(c.telefone)}</p>
              </div>
            ))}
          </div>
        </FinanceDetailSectionCard>
      )}

      {detail.observacoes?.trim() && (
        <FinanceDetailSectionCard
          title='Observações'
          icon={Building2}
          accent='#64748b'
          className='lg:col-span-2'
        >
          <p className='whitespace-pre-wrap text-sm leading-relaxed text-text-primary'>
            {detail.observacoes.trim()}
          </p>
        </FinanceDetailSectionCard>
      )}
    </div>
  )
}
